Router = App.loadClass 'core::Router'

class exports.PreferencesRouter extends Router

    prefix: 'Preferences'
    module_name: 'PreferencesRouter'

    register: () ->
        @module = angular.module @module_name, ['ui.router', 'ui.bootstrap']

        @service 'admin::Angular/Preferences/PreferencesService', ['$http']

        @controller 'admin::Angular/Preferences/PreferencesController', [
            '$scope'
            '$transitions'
            'Preferences.Services.PreferencesService'
        ]


    registerRoutes: ($stateProvider) ->
        $stateProvider
            .state 'admin.preferences',
                url: '/preferences'
                templateUrl: 'backend/admin/preferences/sidebar'
                controller: ['$scope', '$state', ($scope, $state) ->
                    # Do nothing but load the main dialog
                    $scope.show_fullpage = true
                    $state.go '.dialog', null,
                        location: 'replace'
                ]

            .state 'admin.preferences.dialog',
                url: '/dialog'
                views:
                    fullpage:
                        templateUrl: 'backend/admin/preferences/dialog'
                        controller: 'Preferences.Controllers.PreferencesController'
